import {defineMessages} from 'react-intl';

export const tooltipMessages = defineMessages({
  mute: { id: 'tooltips.mute' },
  pause_audio: { id: 'tooltips.pause_audio' },
  play_audio: { id: 'tooltips.play_audio' },
  rewind: { id: 'tooltips.rewind' },
  unmute: { id: 'tooltips.unmute' },
  subtitles: { id: 'tooltips.subtitles' },
});
